import React from 'react';
import { motion } from 'framer-motion';
const bonuses = [{
  icon: '🧾',
  title: 'BONO 1 — Plantilla de costos editable',
  desc: 'Calculá exactamente cuánto te cuesta cada receta y cuánto tenés que cobrar para ganar.',
  highlight: '👉 Dejás de adivinar precios y empezás a tener un negocio real.'
}, {
  icon: '📲',
  title: 'BONO 2 — Textos para vender por WhatsApp',
  desc: 'Mensajes listos para responder consultas, presentar tus productos y cerrar ventas sin sentir que molestás.'
}, {
  icon: '📦',
  title: 'BONO 3 — Ideas de packaging económico',
  desc: 'Cómo hacer que tus productos se vean irresistibles sin gastar de más.',
  highlight: '👉 Más valor percibido = podés cobrar mejor.'
}, {
  icon: '📸',
  title: 'BONO 4 — Ideas de contenido para Instagram',
  desc: 'Qué publicar para atraer clientes, mostrar lo que hacés y vender todos los días sin depender del boca a boca.'
}];
export function Bonuses() {
  return <section className="py-20 md:py-28 bg-white relative" data-id="element-13">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-14">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-15">
          
          <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-16">
            <span className="text-brown-dark" data-id="element-17">Además, te llevás</span>{' '}
            <span className="text-olive" data-id="element-18">estos bonos</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start" data-id="element-19">
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="lg:col-span-5 sticky top-8" data-id="element-20">
            <img src="https://cdn.magicpatterns.com/uploads/5Ju6v6bfvHbwnpupdcsJeH/hacer_una_mejor_version_de_202604282218.jpg" alt="Mockups del Ebook y Bonos" className="w-full h-auto rounded-2xl shadow-2xl" data-id="element-21" />
          </motion.div>

          <div className="lg:col-span-7 space-y-6" data-id="element-22">
            {bonuses.map((bonus, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="bg-beige p-6 md:p-8 rounded-2xl border border-beige-dark shadow-sm hover:shadow-md transition-shadow" data-id="element-23">
                <div className="flex items-start gap-4" data-id="element-24">
                  <div className="text-4xl flex-shrink-0" data-id="element-25">{bonus.icon}</div>
                  <div data-id="element-26">
                    <h3 className="text-xl font-bold text-brown-dark mb-2" data-id="element-27">
                      {bonus.title}
                    </h3>
                    <p className="text-brown mb-2" data-id="element-28">{bonus.desc}</p>
                    {bonus.highlight && <p className="text-olive font-semibold mt-3" data-id="element-29">
                        {bonus.highlight}
                      </p>}
                  </div>
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}